import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export const SSO_REFERENCES = ['expodoc'];

export default class SourceModel extends ApiModel {
  static get path() {
    return '/backend/sources/{?id}';
  }

  @computed
  public get sourceName(): string {
    return this.get('name', '');
  }

  @computed
  public get reference(): string {
    return this.get('reference', '');
  }

  @computed
  public get isSso(): boolean {
    return SSO_REFERENCES.includes(this.reference);
  }

  @computed
  public get supportsConnectionTest(): boolean {
    return !this.isSso;
  }

  @computed
  public get supportsQueryParameters(): boolean {
    return !this.isSso;
  }
}
